import React from 'react';
import Landing2Layout from './layout/Landing2Layout';
import PageHero2 from './components/PageHero2';
import SectionHead from './components/SectionHead';
import Sym from './components/Sym';
import CTABand2 from './sections2/CTABand2';

/**
 * Página Seguridad. Ajustes de negocio aplicados (23-jul):
 *  - Fuera ISO/IEC 27001 (no certificado) y «PAC autorizado» (PaySlip NO timbra).
 *  - «Datos en México» suavizado: la e.firma se describe como aislada/con acceso
 *    restringido, sin afirmar la ubicación geográfica del hosting.
 *  - LFPDPPP → «Conforme a la ley mexicana».
 *  - CTA sin «Sin tarjeta» (la prueba pide tarjeta al inicio).
 */
const STEPS = [
  { icon: 'vpn_key', title: 'Subes tu e.firma', tag: 'Cifrado AES-256', desc: 'Se cifra en tu navegador antes de salir de tu equipo. Nadie la lee en tránsito.' },
  { icon: 'shield', title: 'Se guarda en una bóveda aislada', tag: 'Aislada', desc: 'Separada del resto de tu información y con acceso restringido.' },
  { icon: 'policy', title: 'Uso limitado y auditado', tag: 'Acceso por rol', desc: 'Solo la usamos para consultar el SAT. Cada acceso queda registrado.' },
  { icon: 'restore', title: 'Respaldada y bajo tu control', tag: 'Revocable', desc: 'Respaldos diarios y la revocas cuando quieras, sin trámites.' },
];

const CHIPS = [
  { icon: 'lock', t: 'Cifrado AES-256' },
  { icon: 'backup', t: 'Respaldos diarios' },
  { icon: 'admin_panel_settings', t: 'Acceso por rol' },
  { icon: 'shield', t: 'e.firma aislada' },
  { icon: 'account_balance', t: 'Solo consulta al SAT' },
  { icon: 'policy', t: 'Conforme a la ley mexicana' },
];

const Dash = () => (
  <div style={{ width: 3, height: 26, marginLeft: 21, background: 'repeating-linear-gradient(180deg,#2F6BFF 0 5px,transparent 5px 11px)', backgroundSize: '3px 11px', opacity: 0.5 }} />
);

const Seguridad2 = () => (
  <Landing2Layout title="Seguridad — PaySlip">
    <PageHero2
      eyebrow="Seguridad"
      title="Tu información y tu e.firma,"
      accent="blindadas"
      subtitle="Tu e.firma es lo más sensible que nos confías. Por eso la tratamos con el mismo cuidado que un banco trata tu dinero: cifrada, aislada y bajo tu control."
      maxWidth={640}
    />

    <section style={{ maxWidth: 1000, margin: '0 auto', padding: 'clamp(32px,5vw,56px) clamp(20px,5vw,40px) clamp(48px,7vw,80px)' }}>
      <SectionHead
        eyebrow="El viaje de tu e.firma"
        title="Protegida en cada paso"
        accent="del proceso"
        subtitle="Desde que la subes hasta que la usamos: esto es lo que le pasa a tu e.firma dentro de PaySlip."
      />
      <div data-dark style={{ position: 'relative', overflow: 'hidden', background: 'linear-gradient(160deg,#0A1326,#0C1A34)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 24, padding: 'clamp(30px,4vw,48px) clamp(20px,4vw,40px)', marginTop: 40 }}>
        <div style={{ position: 'absolute', top: -110, right: -50, width: 340, height: 340, borderRadius: '50%', background: 'radial-gradient(circle,rgba(47,107,255,.22),transparent 65%)', filter: 'blur(12px)' }} />
        <div style={{ position: 'relative', maxWidth: 560, margin: '0 auto' }}>
          {STEPS.map((s, i) => (
            <React.Fragment key={s.title}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                <div style={{ width: 46, height: 46, borderRadius: 13, background: 'rgba(47,107,255,.14)', border: '1px solid rgba(111,160,255,.3)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                  <Sym name={s.icon} size={24} color="#6FA0FF" />
                </div>
                <div style={{ paddingTop: 1 }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 9, marginBottom: 5 }}>
                    <h3 style={{ font: "600 1.15rem 'Source Serif 4'", color: '#F4F7FC', margin: 0 }}>{s.title}</h3>
                    <span style={{ font: "700 .62rem 'IBM Plex Mono'", letterSpacing: '.08em', textTransform: 'uppercase', color: '#8FB4FF', background: 'rgba(47,107,255,.14)', border: '1px solid rgba(47,107,255,.3)', borderRadius: 999, padding: '3px 8px' }}>{s.tag}</span>
                  </div>
                  <p style={{ font: "400 .96rem/1.5 'Hanken Grotesk'", color: '#AEBAD2', margin: 0 }}>{s.desc}</p>
                </div>
              </div>
              {i < STEPS.length - 1 && <Dash />}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 10, marginTop: 26 }}>
        {CHIPS.map((c) => (
          <span key={c.t} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: 'var(--well-row)', border: '1px solid var(--border-soft)', borderRadius: 999, padding: '9px 15px', font: "600 .8rem 'IBM Plex Mono'", color: 'var(--body-strong)' }}>
            <Sym name={c.icon} size={16} color="#6FA0FF" />{c.t}
          </span>
        ))}
      </div>
    </section>

    <CTABand2
      title="Tranquilidad para ti y tu equipo"
      subtitle="Empieza tu prueba de 15 días, sin riesgo."
    />
  </Landing2Layout>
);

export default Seguridad2;
